<template>
  <button class="ms-button btn" :class="[type]" :disabled="disabled" v-on="listeners">
    <div :class="['icon24 icon left', leftIcon]" v-if="leftIcon">&nbsp;</div>
    <div
      class="text"
      :class="[{ 'pl-0': leftIcon, 'pr-0': rightIcon }]"
      v-bind:style="{ width: width + 'px', height: height + 'px' }"
      v-if="text"
    >
      {{ text }}
    </div>
    <div class="right rightText" v-if="rightText">{{ rightText }}</div>
    <div :class="['icon24 icon right', rightIcon]" v-if="rightIcon"></div>
  </button>
</template>
<script>
export default {
  name: "msButton",
  props: {
    //Text hiển thị
    text: {
      default: null,
      type: String,
    },
    //Size hiển thị
    width: {
      default: null,
      type: Number,
    },
    //Size hiển thị
    height: {
      default: null,
      type: Number,
    },
    //Icon trái
    leftIcon: {
      default: null,
      type: String,
    },
    //Icon phải
    rightIcon: {
      default: null,
      type: String,
    },
    //Loại button gồm 3 loại primary/secondary/third/four để hiện thị style tương ứng
    type: {
      default: "primary",
      type: String,
    },
    /**
     * Trạng thái button disabled
     */
    disabled: {
      default: false,
      type: Boolean,
    },
    /**
     * Chữ hiển bên phải
     */
    rightText: {
      default: null,
      type: String,
    },
  },
  data() {
    return {};
  },
  computed: {
    //Sự kiện từ 1 dòng dữ liệu emit ra ngoài
    listeners() {
      const me = this;
      return {
        click: (event) => {
          me.$emit("click", event);
        },
        mousedown: (event) => {
          event.preventDefault();
        },
        keydown: (event) => {
          me.$emit("keydown", event);
        },
        focus: (event) => {
          me.$emit("focus", event);
        },
      };
    },
  },
};
</script>
<style scoped lang="scss">
// @media screen and (max-width: 1366px) {
// 	@import '@/assets/scss/_sm-variables.scss';
// 	@import '@/assets/scss/components/msButton.scss';
// }
// @media screen and (min-width: 1367px) {
// 	@import '@/assets/scss/_variables.scss';
// 	@import '@/assets/scss/components/msButton.scss';
// }

@import "@/assets/scss/_variables.scss";
@import "@/assets/scss/components/msButton.scss";
</style>
